import React from "react";
import { Button, Col, Container, Row, Card, Badge } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircleFill, ShieldLockFill } from 'react-bootstrap-icons';
import "./css/dao.css";

export default function Daovotingsystem() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const sendToLaunchpad = () => {
    navigate(`${config.baseUrl}launchpad`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="dao position-relative pt-5 pb-0 overflow-hidden">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center">
            <Col lg={12}>
              <div className="">
                <Card className=" bg-transparent border-0">
                  <Card.Body>
                    <div className=" position-relative">
                      <Col lg={8}>
                        <div className="position-relative d-inline-block text-left mb-3">

                          <h1 className=" text-white lh-sm mb-4">
                            <span className="position-relative z-1">
                              INFI DAO {" "}
                              <span className="fw-normal">
                                – Empowering the Community, Securing the Future
                              </span>
                            </span>
                            <div className="polygon" style={{ right: "-120px" }}>
                              <img src="images/shape/polygon.png" alt="" style={{ width: "208px" }} />
                            </div>
                          </h1>

                          <p className="text-light-grey2 position-relative">The INFI DAO voting system is transparent, decentralized, and community-driven. Real power is given to those who stake INFI and believe in the ecosystem.</p>
                        </div>
                      </Col>
                      <div className="position-relative">
                        <Row className="gy-4">

                          <Col md={6}>
                            <div className="cardStyle1">
                              <Card className="h-100 shadow-sm cardBox1 text-white">
                                <Card.Body>
                                  <Card.Title>
                                    <CheckCircleFill className="me-2 text-success" />
                                    How it Works
                                  </Card.Title>
                                  <Card.Text className="text-light-grey2 mb-0">
                                    Stake at least <strong>1,000 INFI</strong> to vote on critical decisions:
                                    <ul>
                                      <li className="mt-2">New feature development</li>
                                      <li className="mt-2">Treasury and fund management</li>
                                      <li className="mt-2">Ecosystem direction and strategy</li>
                                    </ul>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="cardStyle1">
                              <Card className="h-100 shadow-sm cardBox1 text-white">
                                <Card.Body>
                                  <Card.Title>🗳️ One Wallet = One Vote</Card.Title>
                                  <Card.Text className="text-light-grey2 mb-0">
                                    Each wallet with 1,000+ INFI gets <strong>one vote</strong>, no matter how much is staked. This ensures <Badge bg="dark" text="white">fairness</Badge> and prevents centralized control.
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="cardStyle1">
                              <Card className="h-100 shadow-sm cardBox1 text-white">
                                <Card.Body>
                                  <Card.Title>💡 Community - Led Proposals</Card.Title>
                                  <Card.Text className="text-light-grey2 mb-0">
                                    Anyone can submit proposals, but only stakers can vote. This model encourages <strong>innovation</strong> with responsible participation.
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="cardStyle1">
                              <Card className="h-100 shadow-sm cardBox1 text-white">
                                <Card.Body>
                                  <Card.Title>
                                    <ShieldLockFill className="me-2 text-danger" />
                                    Security First – 48h Compensation Plan
                                  </Card.Title>
                                  <Card.Text className="text-light-grey2 mb-0">
                                    If a verified scam happens, INFI DAO can vote to activate a <strong>48-hour fraud compensation</strong> plan, protecting the community and reinforcing trust.
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </div>
                          </Col>

                          <Col md={12}>
                            <div className="cardStyle1">
                              <Card className="h-100 shadow-sm cardBox1 text-white">
                                <Card.Body>
                                  <Card.Title>⚙️ SbSe Protocol – The Backbone of INFI</Card.Title>
                                  <Card.Text className="text-light-grey2">
                                    <p>SbSe Protocol powers the entire INFI ecosystem:</p>
                                    <ul>
                                      <li className="mb-1">INFI DAO Voting</li>
                                      <li className="mb-1">INFI Launchpad</li>
                                      <li className="mb-1">MultiChain CDEX</li>
                                      <li className="mb-1">Instant Swap</li>
                                      <li>Upcoming ecosystem tools</li>
                                    </ul>
                                    Every decision is community-governed — not by a central authority.
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </div>
                          </Col>

                          <Col md={12}>
                            <div className="text-center mt-5 ">
                              <h1 className="text-white">Together, we’re not just building tools.</h1>
                              <p className="fw-bold text-light-grey2 my-4">We’re shaping the future of decentralized finance — safe, transparent, and community-led.</p>
                              <Button variant="white-gradient" className="btn-white-gradient text-black px-4 rounded-5 position-relative z-2">Community Governed</Button>
                            </div>
                          </Col>

                        </Row>
                      </div>
                    </div>

                  </Card.Body>
                </Card>
              </div>
            </Col>

          </Row>
        </Container>
      </section >
    </>
  );
}
